import { jsx } from "react/jsx-runtime";
import { cn } from "../../../lib/utils.js";
const COLORS = ["#FF6666", "#FFC809", "#26C9CB"];
const BORDER_COLORS = ["#D54141", "#D77F27", "#009B9B"];
const POLYGON_TITLE_RE = /^\s*(\{\{\s*\d+\s*\}\}\s*,?\s*)+$/;
function parsePolygonTitle(title) {
  if (!title || !POLYGON_TITLE_RE.test(title)) return null;
  const counts = title.split(",").map((t) => parseInt(t.replace(/[{}\s]/g, ""), 10)).filter((n) => Number.isInteger(n) && n > 0);
  return counts.length > 0 ? counts : null;
}
function chunkRows(total) {
  const rows = [];
  let remaining = total;
  while (remaining > 0) {
    const add = Math.min(3, remaining);
    rows.push(add);
    remaining -= add;
  }
  return rows;
}
function PolygonRenderer({ counts, shape = "circle" }) {
  return /* @__PURE__ */ jsx("div", { className: "flex flex-wrap justify-center items-center gap-2 p-2", children: counts.map((count, groupIndex) => {
    const colorIndex = groupIndex % COLORS.length;
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: "flex flex-1 flex-col items-center justify-center gap-2",
        children: chunkRows(count).reverse().map((rowCount, rowIndex) => /* @__PURE__ */ jsx("div", { className: "flex justify-start gap-1", children: Array.from({ length: rowCount }, (_, shapeIndex) => /* @__PURE__ */ jsx(
          "div",
          {
            "data-polygon-shape": true,
            className: cn("w-8 h-8", shape === "square" ? "" : "rounded-full"),
            style: {
              backgroundColor: COLORS[colorIndex],
              border: `2px solid ${BORDER_COLORS[colorIndex]}`
            }
          },
          `shape-${shapeIndex}`
        )) }, `row-${rowIndex}`))
      },
      `polygon-${groupIndex}`
    );
  }) });
}
export {
  PolygonRenderer,
  parsePolygonTitle
};
//# sourceMappingURL=polygon-renderer.js.map
